// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"6dd43026","977":"f615ab9a"}[chunkId] + ".chunk.js";
};